import { conversionTables } from '../conversionTables';
const getSymbol = (unitId, systemTo) => conversionTables[systemTo]['en-UK'][unitId].general;
export default getSymbol;
//# sourceMappingURL=getSymbol.js.map